import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/5511976974905?text=Olá!%20Gostaria%20de%20mais%20informações%20sobre%20a%20Equilybra%20Company."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[hsl(142_70%_45%)] text-primary-foreground shadow-lg hover:bg-[hsl(142_70%_40%)] hover:scale-110 transition-all duration-300 animate-pulse-slow"
      aria-label="Contato via WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
};

export default WhatsAppButton;
